import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../api';
import {
  countriesOptionsFormatting,
  generateCurrencies,
  languagesOptionsFormatting,
  legalEntitiesOptionsFormatting,
} from '../../services/helpers/dataStructuring';
import {
  REQUEST_COUNTRIES,
  REQUEST_CURRENCIES,
  REQUEST_LEGAL_ENTITIES,
  REQUEST_LOCALES,
} from '../constants/actionTypes';

export const actionRequestLocales = createAsyncThunk(REQUEST_LOCALES, async () => {
  const { data } = await api.getLocaleOptions();

  return languagesOptionsFormatting(data.items);
});

export const actionRequestCountries = createAsyncThunk(REQUEST_COUNTRIES, async () => {
  const { data } = await api.getCountryOptions();

  return countriesOptionsFormatting(data.items);
});

export const actionRequestLegalEntities = createAsyncThunk(REQUEST_LEGAL_ENTITIES, async () => {
  const { data } = await api.getLegalEntitiesOptions();

  return legalEntitiesOptionsFormatting(data.items);
});

export const actionRequestCurrencies = createAsyncThunk(REQUEST_CURRENCIES, async () => {
  const storedCurrencies = JSON.parse(window.localStorage.getItem('currencies'));

  if (storedCurrencies?.data && new Date() < storedCurrencies?.expirationDate) {
    return storedCurrencies.data;
  }

  const {
    data: { items },
  } = await api.getCurrency({ size: 0, sortParams: { value: 'code', type: 'asc' } });

  return generateCurrencies(items);
});
